import React from 'react';
import { Features } from './components/Features';
import { Hero } from './components/Hero';
import { MetaPixel } from './components/MetaPixel';
import { Pricing } from './components/Pricing';
export function App() {
  return <div className="yoga-page min-h-screen bg-cream font-sans text-brand-900 selection:bg-brand-500 selection:text-white" data-id="element-0" data-mp="3k89rzt3nuthw">
      <MetaPixel data-id="element-1" data-mp="3fb9mpkemxuru" />
      <Hero data-id="element-2" data-mp="3f8n9p58z6n28" />
      <main data-id="element-3" data-mp="2rknmgfavhese">
        <Features data-id="element-4" data-mp="2rkdsyhqmcphy" />
        <Pricing data-id="element-5" data-mp="2rlozuqfd2dda" />
      </main>
    </div>;
}